import React from 'react';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { WebPushIcon } from 'assets/icons/WebPushIcon';
import { WebPushIconAlt } from 'assets/icons/WebPushIconAlt';

export const WebPush = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: WebPushIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#0CBFE7'
            }
        },
        opened: {
            icon: WebPushIconAlt,
            iconProps: { borderColor: '#0CBFE7' }
        },
        warning: {
            icon: WebPushIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions
    }}/>
}
